import { Link } from 'react-router-dom';
import { FooterMobileStyled, FooterStyled } from '../BackofficeLayoutStyled';
import { useTranslation } from 'react-i18next';
import { Desktop, Mobile } from '../../../App';
import { PRIVACY_POLICY, TERMS_OF_USE } from '../../../routes/routes';
import { FooterText } from '../../../styles/FontStyles';
import { Flexed } from '../../../styles/GlobalComponents';
import { globalImages } from '../../../styles/GlobalStyles';
import { FlexEnd } from '../../../styles/stylesStyled';
import { useEffect } from 'react';
import { useAppSelector } from '../../../app/hooks';
import { dateDifferenceInDaysFromToday } from '../../../helpers/helperFunctions';

const ElevenLabsWidget = () => {
  useEffect(() => {
    // Prevent duplicate script injection
    if (
      !document.querySelector(
        'script[src="https://unpkg.com/@elevenlabs/convai-widget-embed"]'
      )
    ) {
      const script = document.createElement('script');
      script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
      script.async = true;
      script.type = 'text/javascript';
      document.body.appendChild(script);
    }
  }, []);

  return (
    <elevenlabs-convai agent-id='agent_01jy17wxwyfrgvmdmjdqqphqyr'></elevenlabs-convai>
  );
};

const FooterDesktop = ({ licenceIsExpired }: any) => {
  const { t } = useTranslation('layout');

  return (
    <FooterStyled>
      <FlexEnd style={{ width: '100%', maxWidth: 1500, padding: '0 100px' }}>
        <Flexed gap='20px' center>
          <img src={globalImages.appLogo} alt='logo' />
          <div>
            <Flexed gap='10px' wrap='true'>
              <Link to={TERMS_OF_USE}>
                <FooterText mb='3'>Terms and Conditions</FooterText>
              </Link>
              <Link to={PRIVACY_POLICY}>
                <FooterText mb='3'>{t('footer.privacy_policy')}</FooterText>
              </Link>
            </Flexed>
            <FooterText mb='3'>Copyright © 2025 Travelution.</FooterText>
          </div>
        </Flexed>
      </FlexEnd>
      {!licenceIsExpired && <ElevenLabsWidget />}
    </FooterStyled>
  );
};

const FooterMobile = ({ licenceIsExpired }: any) => {
  const { t } = useTranslation('layout');
  return (
    <FooterMobileStyled>
      <Flexed gap='20px'>
        <img src={globalImages.appLogo} alt='logo' />
        <div>
          <Flexed gap='10px' wrap='true'>
            <Link to={TERMS_OF_USE}>
              <FooterText mb='3'>Terms and Conditions</FooterText>
            </Link>
            <Link to={PRIVACY_POLICY}>
              <FooterText mb='3'>{t('footer.privacy_policy')}</FooterText>
            </Link>
          </Flexed>
          <FooterText mb='3'>Copyright © 2025 Travelution.</FooterText>
        </div>
      </Flexed>
      {!licenceIsExpired && <ElevenLabsWidget />}
    </FooterMobileStyled>
  );
};

export const Footer = () => {
  const { user } = useAppSelector((state) => state.auth.userInfo);
  const licenceIsExpired =
    dateDifferenceInDaysFromToday(user?.currentVirtualOfficeLicence?.dateEnd) ==
    0;

  return (
    <>
      <Desktop>
        <FooterDesktop licenceIsExpired={licenceIsExpired} />
      </Desktop>
      <Mobile>
        <FooterMobile licenceIsExpired={licenceIsExpired} />
      </Mobile>
    </>
  );
};
